var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoriaFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_171:20162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D9E5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4423 34.3781C51.7481 34.3781 51.1851 33.815 51.1851 33.1208V28.1996C51.1851 27.5055 51.7481 26.9424 52.4423 26.9424C53.1364 26.9424 53.6995 27.5055 53.6995 28.1996V33.1208C53.6995 33.815 53.1364 34.3781 52.4423 34.3781Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3915 34.3781C56.6974 34.3781 56.1343 33.815 56.1343 33.1208V28.1996C56.1343 27.5055 56.6974 26.9424 57.3915 26.9424C58.0857 26.9424 58.6487 27.5055 58.6487 28.1996V33.1208C58.6487 33.815 58.0857 34.3781 57.3915 34.3781Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5404 43.9826C41.8463 43.9826 41.2832 43.4195 41.2832 42.7253V37.8041C41.2832 37.11 41.8463 36.5469 42.5404 36.5469C43.2346 36.5469 43.7977 37.11 43.7977 37.8041V42.7253C43.7977 43.4195 43.2346 43.9826 42.5404 43.9826Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4897 43.9826C46.7955 43.9826 46.2324 43.4195 46.2324 42.7253V37.8041C46.2324 37.11 46.7955 36.5469 47.4897 36.5469C48.1838 36.5469 48.7469 37.11 48.7469 37.8041V42.7253C48.7469 43.4195 48.1838 43.9826 47.4897 43.9826Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4423 43.9826C51.7481 43.9826 51.1851 43.4195 51.1851 42.7253V37.8041C51.1851 37.11 51.7481 36.5469 52.4423 36.5469C53.1364 36.5469 53.6995 37.11 53.6995 37.8041V42.7253C53.6995 43.4195 53.1364 43.9826 52.4423 43.9826Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3915 43.9826C56.6974 43.9826 56.1343 43.4195 56.1343 42.7253V37.8041C56.1343 37.11 56.6974 36.5469 57.3915 36.5469C58.0857 36.5469 58.6487 37.11 58.6487 37.8041V42.7253C58.6487 43.4195 58.0857 43.9826 57.3915 43.9826Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5878 53.5939C36.8936 53.5939 36.3306 53.0308 36.3306 52.3367V47.4154C36.3306 46.7213 36.8936 46.1582 37.5878 46.1582C38.282 46.1582 38.845 46.7213 38.845 47.4154V52.3367C38.845 53.0308 38.282 53.5939 37.5878 53.5939Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5404 53.5939C41.8463 53.5939 41.2832 53.0308 41.2832 52.3367V47.4154C41.2832 46.7213 41.8463 46.1582 42.5404 46.1582C43.2346 46.1582 43.7977 46.7213 43.7977 47.4154V52.3367C43.7977 53.0308 43.2346 53.5939 42.5404 53.5939Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4897 53.5939C46.7955 53.5939 46.2324 53.0308 46.2324 52.3367V47.4154C46.2324 46.7213 46.7955 46.1582 47.4897 46.1582C48.1838 46.1582 48.7469 46.7213 48.7469 47.4154V52.3367C48.7469 53.0308 48.1838 53.5939 47.4897 53.5939Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4423 53.5939C51.7481 53.5939 51.1851 53.0308 51.1851 52.3367V47.4154C51.1851 46.7213 51.7481 46.1582 52.4423 46.1582C53.1364 46.1582 53.6995 46.7213 53.6995 47.4154V52.3367C53.6995 53.0308 53.1364 53.5939 52.4423 53.5939Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3915 53.5939C56.6974 53.5939 56.1343 53.0308 56.1343 52.3367V47.4154C56.1343 46.7213 56.6974 46.1582 57.3915 46.1582C58.0857 46.1582 58.6487 46.7213 58.6487 47.4154V52.3367C58.6487 53.0308 58.0857 53.5939 57.3915 53.5939Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5404 63.1984C41.8463 63.1984 41.2832 62.6353 41.2832 61.9412V57.0199C41.2832 56.3258 41.8463 55.7627 42.5404 55.7627C43.2346 55.7627 43.7977 56.3258 43.7977 57.0199V61.9412C43.7977 62.6353 43.2346 63.1984 42.5404 63.1984Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4897 63.1984C46.7955 63.1984 46.2324 62.6353 46.2324 61.9412V57.0199C46.2324 56.3258 46.7955 55.7627 47.4897 55.7627C48.1838 55.7627 48.7469 56.3258 48.7469 57.0199V61.9412C48.7469 62.6353 48.1838 63.1984 47.4897 63.1984Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4423 63.1984C51.7481 63.1984 51.1851 62.6353 51.1851 61.9412V57.0199C51.1851 56.3258 51.7481 55.7627 52.4423 55.7627C53.1364 55.7627 53.6995 56.3258 53.6995 57.0199V61.9412C53.6995 62.6353 53.1364 63.1984 52.4423 63.1984Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3915 63.1984C56.6974 63.1984 56.1343 62.6353 56.1343 61.9412V57.0199C56.1343 56.3258 56.6974 55.7627 57.3915 55.7627C58.0857 55.7627 58.6487 56.3258 58.6487 57.0199V61.9412C58.6487 62.6353 58.0857 63.1984 57.3915 63.1984Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4423 72.8097C51.7481 72.8097 51.1851 72.2466 51.1851 71.5525V66.6313C51.1851 65.9371 51.7481 65.374 52.4423 65.374C53.1364 65.374 53.6995 65.9371 53.6995 66.6313V71.5525C53.6995 72.2466 53.1364 72.8097 52.4423 72.8097Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2934 65.374C67.9875 65.374 68.5506 65.9371 68.5506 66.6313V71.5525C68.5506 72.2466 67.9875 72.8097 67.2934 72.8097C66.5992 72.8097 66.0361 72.2466 66.0361 71.5525V66.6313C66.0361 65.9371 66.5992 65.374 67.2934 65.374Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1986 55.7627C77.8928 55.7627 78.4559 56.3258 78.4559 57.0199V61.9412C78.4559 62.6353 77.8928 63.1984 77.1986 63.1984C76.5045 63.1984 75.9414 62.6353 75.9414 61.9412V57.0199C75.9414 56.3258 76.5045 55.7627 77.1986 55.7627Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.246 55.7627C72.9402 55.7627 73.5032 56.3258 73.5032 57.0199V61.9412C73.5032 62.6353 72.9402 63.1984 72.246 63.1984C71.5518 63.1984 70.9888 62.6353 70.9888 61.9412V57.0199C70.9888 56.3258 71.5518 55.7627 72.246 55.7627Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2934 55.7627C67.9875 55.7627 68.5506 56.3258 68.5506 57.0199V61.9412C68.5506 62.6353 67.9875 63.1984 67.2934 63.1984C66.5992 63.1984 66.0361 62.6353 66.0361 61.9412V57.0199C66.0361 56.3258 66.5992 55.7627 67.2934 55.7627Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1479 46.1582C82.842 46.1582 83.4051 46.7213 83.4051 47.4154V52.3367C83.4051 53.0308 82.842 53.5939 82.1479 53.5939C81.4537 53.5939 80.8906 53.0308 80.8906 52.3367V47.4154C80.8906 46.7213 81.4537 46.1582 82.1479 46.1582Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1986 46.1582C77.8928 46.1582 78.4559 46.7213 78.4559 47.4154V52.3367C78.4559 53.0308 77.8928 53.5939 77.1986 53.5939C76.5045 53.5939 75.9414 53.0308 75.9414 52.3367V47.4154C75.9414 46.7213 76.5045 46.1582 77.1986 46.1582Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.246 46.1582C72.9402 46.1582 73.5032 46.7213 73.5032 47.4154V52.3367C73.5032 53.0308 72.9402 53.5939 72.246 53.5939C71.5518 53.5939 70.9888 53.0308 70.9888 52.3367V47.4154C70.9888 46.7213 71.5518 46.1582 72.246 46.1582Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2934 46.1582C67.9875 46.1582 68.5506 46.7213 68.5506 47.4154V52.3367C68.5506 53.0308 67.9875 53.5939 67.2934 53.5939C66.5992 53.5939 66.0361 53.0308 66.0361 52.3367V47.4154C66.0361 46.7213 66.5992 46.1582 67.2934 46.1582Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1986 36.5469C77.8928 36.5469 78.4559 37.11 78.4559 37.8041V42.7253C78.4559 43.4195 77.8928 43.9826 77.1986 43.9826C76.5045 43.9826 75.9414 43.4195 75.9414 42.7253V37.8041C75.9414 37.11 76.5045 36.5469 77.1986 36.5469Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.246 36.5469C72.9402 36.5469 73.5032 37.11 73.5032 37.8041V42.7253C73.5032 43.4195 72.9402 43.9826 72.246 43.9826C71.5518 43.9826 70.9888 43.4195 70.9888 42.7253V37.8041C70.9888 37.11 71.5518 36.5469 72.246 36.5469Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2934 36.5469C67.9875 36.5469 68.5506 37.11 68.5506 37.8041V42.7253C68.5506 43.4195 67.9875 43.9826 67.2934 43.9826C66.5992 43.9826 66.0361 43.4195 66.0361 42.7253V37.8041C66.0361 37.11 66.5992 36.5469 67.2934 36.5469Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2934 26.9424C67.9875 26.9424 68.5506 27.5055 68.5506 28.1996V33.1208C68.5506 33.815 67.9875 34.3781 67.2934 34.3781C66.5992 34.3781 66.0361 33.815 66.0361 33.1208V28.1996C66.0361 27.5055 66.5992 26.9424 67.2934 26.9424Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3915 72.8097C56.6974 72.8097 56.1343 72.2466 56.1343 71.5525V66.6313C56.1343 65.9371 56.6974 65.374 57.3915 65.374C58.0857 65.374 58.6487 65.9371 58.6487 66.6313V71.5525C58.6487 72.2466 58.0857 72.8097 57.3915 72.8097Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3441 34.3781C61.65 34.3781 61.0869 33.815 61.0869 33.1208V28.1996C61.0869 27.5055 61.65 26.9424 62.3441 26.9424C63.0383 26.9424 63.6014 27.5055 63.6014 28.1996V33.1208C63.6014 33.815 63.0383 34.3781 62.3441 34.3781Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3441 43.9826C61.65 43.9826 61.0869 43.4195 61.0869 42.7253V37.8041C61.0869 37.11 61.65 36.5469 62.3441 36.5469C63.0383 36.5469 63.6014 37.11 63.6014 37.8041V42.7253C63.6014 43.4195 63.0383 43.9826 62.3441 43.9826Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3441 53.5939C61.65 53.5939 61.0869 53.0308 61.0869 52.3367V47.4154C61.0869 46.7213 61.65 46.1582 62.3441 46.1582C63.0383 46.1582 63.6014 46.7213 63.6014 47.4154V52.3367C63.6014 53.0308 63.0383 53.5939 62.3441 53.5939Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3441 63.1984C61.65 63.1984 61.0869 62.6353 61.0869 61.9412V57.0199C61.0869 56.3258 61.65 55.7627 62.3441 55.7627C63.0383 55.7627 63.6014 56.3258 63.6014 57.0199V61.9412C63.6014 62.6353 63.0383 63.1984 62.3441 63.1984Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3441 72.8097C61.65 72.8097 61.0869 72.2466 61.0869 71.5525V66.6313C61.0869 65.9371 61.65 65.374 62.3441 65.374C63.0383 65.374 63.6014 65.9371 63.6014 66.6313V71.5525C63.6014 72.2466 63.0383 72.8097 62.3441 72.8097Z",
    stroke: "#D05437",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 11.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_171:20162",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.898039 0 0 0 0 0.92549 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171:20162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_171:20162",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoriaFilled);
export default __webpack_public_path__ + "static/media/historia_filled.db6d2d32.svg";
export { ForwardRef as ReactComponent };